/* eslint-disable arrow-body-style */
import * as _ from 'lodash';

export default function (object) {
  const result = _.some(object, (value) => {
    return value;
  });

  return result || null;
}



// WEBPACK FOOTER //
// ./app/components/Validation/groupOption.js